import SubjectEnum from "../enums/subject.enum";
import ProductEnum from "../enums/product-enum";

const mapSubjectToProduct = (subject: string): string => {
  switch (subject?.toLocaleLowerCase()) {
    case SubjectEnum.READING.toLocaleLowerCase():
      return ProductEnum.MyPathReading;
    case SubjectEnum.MATH.toLocaleLowerCase():
      return ProductEnum.MyPathMath;
    case SubjectEnum.SEL.toLocaleLowerCase():
    case SubjectEnum.PURPOSE.toLocaleLowerCase():
      return ProductEnum.Purpose;
    case SubjectEnum.SCIENCE.toLocaleLowerCase():
      return ProductEnum.Science;
    default:
      return "";
  }
};

export default mapSubjectToProduct;
